import { render, staticRenderFns } from "./InventoryStatusChip.vue?vue&type=template&id=1abc2971&scoped=true&lang=pug&"
import script from "./InventoryStatusChip.vue?vue&type=script&lang=js&"
export * from "./InventoryStatusChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abc2971",
  null
  
)

export default component.exports